import PuzzleChatApi from '../api/PuzzleChatApi';

const PuzzelChatService = {
  startChatHistory: async (
    predatorAllCasesCode: string = '',
    predatorSingleCaseCode: string,
    sourceTenantId: string
  ) => {
    var code = '';

    if (localStorage.getItem('puzzelChatSelectedCase') === 'All Cases') {
      code = predatorAllCasesCode;
    } else {
      code = predatorSingleCaseCode;
    }

    var today = new Date();
    var h = today.getHours();
    var m = today.getMinutes();
    var startTime = h + ':' + m;

    const chatStartRequest = await PuzzleChatApi.startChatHistory(
      localStorage.getItem('puzzelChatSelectedCase') || '',
      code,
      startTime,
      sourceTenantId
    );

    return chatStartRequest;
  },
};

export default PuzzelChatService;
